var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.25C9.5 5.25 10.75 6.5 10.75 8C10.75 9.53125 9.5 10.75 8 10.75C6.46875 10.75 5.25 9.53125 5.25 8C5.25 6.5 6.46875 5.25 8 5.25ZM8 9.25C8.6875 9.25 9.25 8.71875 9.25 8C9.25 7.3125 8.6875 6.75 8 6.75C7.28125 6.75 6.75 7.3125 6.75 8C6.75 8.71875 7.28125 9.25 8 9.25ZM15.5 7.25C15.75 7.25 16 7.5 16 7.75V8.25C16 8.53125 15.75 8.75 15.5 8.75H13.9375C13.5938 11.4688 11.4375 13.625 8.75 13.9688V15.5C8.75 15.7812 8.5 16 8.25 16H7.75C7.46875 16 7.25 15.7812 7.25 15.5V13.9688C4.53125 13.625 2.375 11.4688 2.03125 8.75H0.5C0.21875 8.75 0 8.53125 0 8.25V7.75C0 7.5 0.21875 7.25 0.5 7.25H2.03125C2.375 4.5625 4.53125 2.40625 7.25 2.0625V0.5C7.25 0.25 7.46875 0 7.75 0H8.25C8.5 0 8.75 0.25 8.75 0.5V2.0625C11.4375 2.40625 13.5938 4.5625 13.9375 7.25H15.5ZM8 12.5C10.4688 12.5 12.5 10.5 12.5 8C12.5 5.53125 10.4688 3.5 8 3.5C5.5 3.5 3.5 5.53125 3.5 8C3.5 10.5 5.5 12.5 8 12.5Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0a32b18b.svg";
export { ForwardRef as ReactComponent };